import { createStore } from '@stencil/store';

const initialState = {
  icocertenhancementsOptimizely: false,
  acceptOrCounterofferON: false,
  optimizedleadrouting: false,
  isConsumerMarketConfidenceOn: false,
  acceptOrCounterofferUnassignedON: false,
};

const { on, onChange, state, reset } = createStore(initialState);

export { on, onChange, state, reset };
export default state;
